let url = window.location.origin
let AllUrl = {
  url: {
    dev: "",
    // dev: "http://www.lestory.cn",
  },
  appid: {
    wx: "be1e352ef0d15a01fcdc4bacf429e5b9",
    qq: "101510896",
    xinlang: "2829403593",
    facebook: "1397507653823766",
    ins: "d539702e66884929810e3ccd0ff4d059",
    line: "1514382018",
  },
  redirect_uri: {
    wx_url: url+"/pc_login_callback/wx",
    qq_url: url+"/pc_login_callback/qq",
    xinlang_url: url+"/pc_login_callback/sina",
    facebook_url: url+"/pc_login_callback/facebook",
    ins_url: url+"/pc_login_callback/instagram",
    line_url: url+"/pc_login_callback/line",
  },
};

export default AllUrl;



// WEBPACK FOOTER //
// ./src/constans/url.js